/**
 * @class
 * @name Ticker
 * @author Evan Moon
 */
import { J2000 } from 'src/constants';
var Ticker = /** @class */ (function () {
    function Ticker(date) {
        this.date = date;
        this.startDate = date;
        this.calcPerTick = 1;
        this.actualCalcPerTick = 1;
        this.secondsPerTick = 1;
        this.deltaTIncrement = 1;
        this.epochTime = date.getTime();
    }
    Object.defineProperty(Ticker.prototype, "currentTime", {
        get: function () {
            var date = this.date;
            var m = date.getTime();
            var nextDate = m + this.secondsPerTick;
            this.date = new Date(nextDate);
            this.epochTime = date.getTime();
            return this.date;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Ticker.prototype, "deltaT", {
        get: function () {
            return this.secondsPerTick;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Ticker.prototype, "epochTime", {
        get: function () {
            return this._epochTime;
        },
        set: function (date) {
            this._epochTime = (date - J2000.getTime()) / 1000;
        },
        enumerable: false,
        configurable: true
    });
    Ticker.prototype.setDeltaT = function () {
        if (this.secondsPerTick < this.calcPerTick) {
            this.actualCalcPerTick = this.secondsPerTick;
        }
        else {
            this.actualCalcPerTick = this.calcPerTick;
        }
        this.deltaTIncrement = Math.round(this.secondsPerTick / this.actualCalcPerTick);
        this.secondsPerTick = this.deltaTIncrement * this.actualCalcPerTick;
    };
    Ticker.prototype.setCalcPerTick = function (tick) {
        if (tick === void 0) { tick = 1; }
        this.calcPerTick = tick;
        this.setDeltaT();
    };
    Ticker.prototype.setSecondsPerTick = function (tick) {
        if (tick === void 0) { tick = 1; }
        this.secondsPerTick = tick;
        this.setDeltaT();
    };
    return Ticker;
}());
export { Ticker };
